import NotFound404Icon from 'components/icon/404-icon';
import Link from 'components/link';
import React from 'react';
import styles from './style.module.scss';

//#region Public Types
export type NotFound404PageStyle = {
  /** The colour of the pin head. Default is `#D35313`. */
  pinHeadColour?: React.CSSProperties['color'];
  /** The colour of the pin body. Default is `#F26721`. */
  pinBodyColour?: React.CSSProperties['color'];
};

export type NotFound404PageProps = {
  /** The style of the 404 page. Can be used to override the default pin colours. */
  style?: NotFound404PageStyle;
  /** The email address to display in the get in touch link. */
  email: string;
};
//#endregion

export default function NotFound404Page({ style, email }: NotFound404PageProps) {
  const emailLink = `mailto:${email}`;
  return (
    <div className={styles.component}>
      <div className={styles['pin-wrapper']}>
        <span>404</span>
        <NotFound404Icon style={style} />
      </div>
      <div className={styles['text-wrapper']}>
        <div className={styles.heading}>Page not found!</div>
        <div className={styles.content}>
          <p>This page may have been removed, or the URL you are using is incorrect.</p>
          <p>Go back to our <Link href="/">home page</Link>, or get in touch at <Link href={emailLink}>{email}</Link></p>
        </div>
      </div>
    </div>
  );
}
